module.exports = __webpack_public_path__ + "static/media/20ECE11.eab43f0e.jpg";